<template>
 <div v-if="work">
  <work-record :key="work.slug" v-bind="record" />
  <td-course-card :zh="zh" :content="work.slug" />
 </div>
</template>
<script setup>
import { withSlash } from '@/runtime/site-path.mjs'
import {computed} from 'vue'
import {useRoute} from 'vue-router'
import catalog from '@/data/td-catalog.json'
import WorkRecord from '@/components/work/WorkRecord.vue'
import TdCourseCard from '@/components/td/TdCourseCard.vue'
import {archiveReturn} from '@/components/work/record-utils'
const route=useRoute(),zh=computed(()=>route.path.startsWith('/zh/')),local=p=>withSlash((zh.value?'/zh':'')+p)
const works=catalog.works.filter(w=>w.public)
const work=computed(()=>works.find(w=>w.slug===route.params.slug))
const card=w=>({title:w.title,cover:w.cover||w.poster,year:w.year,path:local('/td/'+w.slug)+(route.query.from?'?from='+encodeURIComponent(route.query.from):'')})
const famName={TOP:'TOP',CHOP:'CHOP',SOP:'SOP',DAT:'DAT',MAT:'MAT',COMP:'COMP',POP:'POP'}
const record=computed(()=>{
 const w=work.value;if(!w)return {};const i=works.findIndex(x=>x.slug===w.slug)
 const t=w.tech||{}
 const fams=Object.entries(t.families||{}).sort((a,b)=>b[1]-a[1]).slice(0,4).map(([k,v])=>`${famName[k]||k} ${v}`).join(' · ')
 const tools=[t.pop&&'POP',t.glsl&&'GLSL',t.python&&'Python',t.ableton&&'Ableton Live'].filter(Boolean).join(' · ')
 const facts=[
  {label:zh.value?'原標題':'Original title',value:w.titleOriginal||''},
  {label:zh.value?'日期':'Date',value:w.date},
  {label:zh.value?'長度':'Length',value:w.seconds?`${Math.round(w.seconds)} ${zh.value?'秒':'s'}`:''},
  {label:zh.value?'工具':'Tools',value:['TouchDesigner',tools].filter(Boolean).join(' · ')},
  {label:zh.value?'節點':'Nodes',value:t.nodes?`${t.nodes.toLocaleString()}（${fams}）`:''},
  {label:zh.value?'存檔次數':'Saves',value:w.iterations?`${w.iterations}${w.spanHours&&w.spanHours>200?(zh.value?`，跨 ${Math.round(w.spanHours/24)} 天`:`, over ${Math.round(w.spanHours/24)} days`):''}`:''},
  {label:zh.value?'互動輸入':'Input',value:w.input||''},
  {label:zh.value?'轉發':'Reposted by',value:w.repost||''},
  {label:zh.value?'掛在模組上':'Built on',value:(w.modules||[]).join(', ')},
 ].filter(f=>f.value)
 // 發表時寫的文字（他的創作清單表：IG 貼文原文，英文；中文一句話說明）
 const postSection=w.post?[{type:'text',id:'post',title:zh.value?'發表時寫的':'Written at release',paragraphs:w.post.split(/\n\s*\n|\n/).map(x=>x.trim()).filter(Boolean),lang:'en'}]:[]
 const modulesNote=(w.modules||[]).length?[{id:'modules',title:zh.value?'它站在哪些模組上':'What it is built on',paragraphs:[zh.value
  ?`這件掛在 ${w.modules.length} 個共用模組上：${w.modules.join('、')}。模組名裡的六位數是它做好的日期；同一個模組出現在好幾件作品裡，就是這一系列的血緣。`
  :`This one is built on ${w.modules.length} shared modules: ${w.modules.join(', ')}. The six digits in a module name are the day it was made; the same module appearing across works is the lineage of this series.`]}]:[]
 const related=works.filter(x=>x.slug!==w.slug&&x.modules?.some(m=>w.modules?.includes(m))).slice(0,3).map(card)
 const blocks=[
  {type:'video',id:'film',title:zh.value?'影片':'Film',src:w.video?.src||null,poster:w.poster||w.cover||null,width:w.video?.width||1080,height:w.video?.height||1920,seconds:w.seconds,audio:w.video?.audio!==false,wide:true},
  ...postSection,
  ...(modulesNote.length?[{type:'text',id:'modules',title:modulesNote[0].title,paragraphs:modulesNote[0].paragraphs,lang:zh.value?'zh-Hant':'en'}]:[]),
 ]
 const links=[...(w.ig?[{url:w.ig,label:zh.value?'Instagram 貼文':'Instagram post'}]:[]),{url:local('/td/'),label:zh.value?'全部 TouchDesigner 每日創作':'All TouchDesigner Daily works'}]
 return {zh:zh.value,title:w.title,subtitle:(zh.value?w.titleZh:'')||(w.titleRaw!==w.title?w.titleRaw:''),intro:zh.value?(w.noteZh||w.titleNote||''):(w.titleNote||''),introLanguage:zh.value&&w.noteZh?'zh-Hant':'en',category:zh.value?'每日創作 · TouchDesigner':'TouchDesigner Daily',year:w.year,cover:undefined,coverCaption:'',facts,sections:[],blocks,links,related:related.length?related:undefined,previous:i>0?card(works[i-1]):undefined,next:i<works.length-1?card(works[i+1]):undefined,backPath:archiveReturn(route,zh.value)}
})
</script>
